import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format, subDays, max  } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink } from "react-router-dom";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
// Material UI Component
import {
  FormGroup,
  FormLabel,
  FormControl,
  // ListItemText,
  TextField,
  // Checkbox,
  // FormControlLabel,
  Grid,
  Select,
  InputLabel,
  Input,
  // MenuItem,
  Modal,
  Backdrop,
  Fade,
  FormHelperText,
  NativeSelect,
  Button,
  Breadcrumbs,
  Typography,
} from "@material-ui/core";
import {
  makeStyles,
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
//cookies
import { get_cookies } from "../../../components/Cookies/Cookies";
import numeral from "numeral";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const FacilitationReport = () => {
  const [uniqueID, setUniqueId] = useState("");
  const [posts, setPosts] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [open, setOpen] = useState(false);
  const [downloadFlag, setDownloadFlag] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });
  

  const today = new Date();
const last60Days = subDays(today, 60);
const fixedMinDate = new Date("2025-05-05");
const minDate = max([last60Days, fixedMinDate]);
const maxDate = today;
  const classes = useStyles();

  const [useridNo, setuseridNo] = useState(get_cookies("branchidno"));
  // console.log(uniqueID);
  // Data Fetching
  useEffect(() => {
    data();
  }, []);

  useEffect(() => {
    if (posts.length > 0) {
      setDownloadFlag(true);
    } else {
      setDownloadFlag(false);
    }
  }, [posts]);
  //search button
  const dataFilter = async () => {
    setDataLoaded(false);
    await axios
      .get(process.env.REACT_APP_API_URL + "getFacilitation", {
        params: {
          date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
          date_to: format(dateRange.endDate, "yyyy-MM-dd"), //format(dateRange.endDate, "yyyy/MM/dd/")
          jc_user_id_no: useridNo,
        //   unique_id: uniqueID,
        },
      })
      .then((res) => {
        console.log("reports", res);
        setPosts(res.data.data);
      })
      .catch((error) => {
        // console.log(error.message);
      });
    setDataLoaded(true);
  };

  const data = async () => {
    setDataLoaded(true);
  };

  const toggle = () => setOpen(!open);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const dateRangeHandler = (range) => {
    setDateRange(range);
    setOpen(false);
  };
  const columns = [
        {
                name: "fromdate",
                label: "From Date",
              },
              {
                name: "todate",
                label: "To Date",
              },
    {
      name: "processdate",
      label: "Proccess Date",
    },
    {
      name: "packagepurchased",
      label: "Total Set ",
//       options: {
//         customBodyRenderLite: (dataIndex) => {
//           let type = posts[dataIndex].packagepurchased;
//           if (type >= 1 && type <= 2) {
//             return `Platinum`;
//           } else if (type >= 3 && type <= 6) {
//             return `Sapphire`;
//           } else if (type >= 7 && type <= 14) {
//             return `Emerald`;
//           } else if (type >= 15 && type <= 30) {
//             return `Ruby`;
//           } else if (type == 31) {
//             return `Diamond`;
//           } else {
//             return `Platinum`;
//           }
//         },
//       },
    },
    {
      name: "netamount",
      label: "Amount",
      options: {
        customHeadRender: (columnMeta) => {
          return (
            <th
              key={columnMeta.index}
              style={{ textAlign: "right" }}
            >
              <div
                style={{
                  textAlign: "right",
                  fontWeight: "400",
                  textTransform: "none",
                }}
              >
                Amount
              </div>
            </th>
          );
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ textAlign: "right" }}>
              {numeral(value).format("0,0.00")}
            </div>
          );
        },
        setCellHeaderProps: () => ({
          style: { alignItems: "flex-end" },
        }),
        setCellProps: () => ({
          style: { textAlign: "right" },
        }),
      },
    },
    {
            name: "action",
            label: "Action",
            options: {
                    download: false, //exclude this column in csv export
                    sort:false,
                    filter: false,
                    customHeadRender: (columnMeta) => {
                        return (
                          <th
                            key={columnMeta.index}
                            
                          >
                            <div
                              style={{
                                fontWeight: "400",
                                textTransform: "none",
                              }}
                            >
                              Action
                            </div>
                          </th>
                        );
                      },
                    customBodyRenderLite: (dataIndex) => {
 
                            let from =  posts[dataIndex].fromdate;
                            let to =  posts[dataIndex].todate;
                            // collectionviewdetails
                            // collectionallocat
                                    return(

                                                           <div style={{textAlign: "center"}}>
                                                                    <NavLink to={"/reports/facilitation-report-view/"+from+"/"+to}>
                                                                            <Button variant="contained" color="primary" style={{backgroundColor: "#4caf50", color:"#fff"}}>
                                                                                    View
                                                                            </Button>
                                                                    </NavLink>

                                                           </div>

                                    )
                            }
            },
    }
  ];

  const options = {
    filter: false,
    // filterType: "dropdown",
    selectableRows: "none",
    filterType: "multiselect",
    responsive: "standard",
    download: false, //add this
    print: false, //add this
    viewColumns: false,
    setFilterChipProps: (colIndex, colName, data) => {
      //console.log(colIndex, colName, data);
      return {
        color: "primary",
        variant: "outlined",
        className: "testClass123",
      };
    },
//     customTableBodyFooterRender: () => {
//       const total = posts.reduce(
//         (sum, row) => sum + parseFloat(row.amount_php || 0),
//         0
//       );

//       return (
//         <TableFooter>
//           <TableRow>
//             <TableCell
//               colSpan={columns.length - 1}
//               align="right"
//               style={{ fontWeight: "bold", color: "black" }}
//             >
//               Total:
//             </TableCell>
//             <TableCell style={{ fontWeight: "bold", color: "black" }}>
//               {numeral(total).format("0,0.00")}
//             </TableCell>
//           </TableRow>
//         </TableFooter>
//       );
//     },

    // tableBodyHeight,
  };

  const style = {
    marginBottom: "1rem",
    marginTop: "2.5em",
  };

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <ShoppingCartIcon />
        </div>
        <Breadcrumbs aria-label="breadcrumb">
          <NavLink to="/reports">
            <h2 className="header-title">Reports</h2>
          </NavLink>
          <Typography color="textPrimary">Facilitation Fee Report</Typography>
        </Breadcrumbs>
      </div>
      <div className="page-container">
        <div style={style}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
              <TextField
                id="outlined-basic"
                label="Select Date"
                variant="outlined"
                onFocus={() => setOpen(true)}
                fullWidth={true}
                inputProps={{ readOnly: true }}
                autoComplete="off"
                value={`${format(dateRange.startDate, "MM/dd/yyyy")} - ${format(
                  dateRange.endDate,
                  "MM/dd/yyyy"
                )}`}
              />
              <DateRangePicker
                open={open}
                toggle={toggle}
                minDate={minDate}
                maxDate={maxDate}
                onChange={(range) => dateRangeHandler(range)}
              />
            </Grid>
            {/* <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                                                <TextField 
                                                                        id="outlined-search" 
                                                                        label="Search by ID" 
                                                                        type="search" 
                                                                        variant="outlined" 
                                                                        value={uniqueID}
                                                                        onChange={e => {
                                                                                setUniqueId(e.target.value);
                                                                        }}
                                                                />
                            </Grid> */}
            <Grid item xs={4} lg={1} xl={1}>
              <Button
                variant="contained"
                style={{ marginTop: "23px" }}
                color="primary"
                onClick={() => {
                  dataFilter();
                }}
              >
                Search
              </Button>
            </Grid>
          </Grid>
        </div>

        {!dataLoaded ? (
          <Preloader />
        ) : (
          <MUIDataTable
            title={
              <div>
                <h3 className="header-title" style={{ color: "#339933" }}>
                  Facilitation Fee Report
                </h3>
              </div>
            }
            data={posts}
            columns={columns}
            options={options}
          />
        )}
      </div>
    </div>
  );
};

export default FacilitationReport;
